// Lib
import React from 'react';
import { useDragLayer } from 'react-dnd';

// Utils
import { isLineAffectedByDrag } from './dragLayerUtil';

// Components
import LineDragLayer from './lineDrag/LineDragLayer';
import CanvasViewportReplica from './CanvasViewportReplica';
import DragLayerErrorRenderer from '../../workspace/dnd/DragLayerErrorRenderer';
import ErrorBoundary from '../../components/error/errorBoundary/ErrorBoundary';

// Styles
import './ConnectedElementDragLayer.scss';

type ConnectedElementDragLayerProps = {
    currentBoardId: string;
};

const ConnectedElementDragLayer = ({ currentBoardId }: ConnectedElementDragLayerProps) => {
    const { itemType, item, isDragging } = useDragLayer((monitor) => ({
        isDragging: monitor.isDragging(),
        itemType: monitor.getItemType(),
        item: monitor.getItem(),
    }));

    if (!isDragging) return null;
    if (!isLineAffectedByDrag(item, itemType)) return null;

    return (
        <div className="ConnectedElementDragLayer">
            <ErrorBoundary ErrorRenderer={DragLayerErrorRenderer}>
                <CanvasViewportReplica currentBoardId={currentBoardId}>
                    <LineDragLayer currentBoardId={currentBoardId} />
                </CanvasViewportReplica>
            </ErrorBoundary>
        </div>
    );
};

export default ConnectedElementDragLayer;
